/* 2023 created for BSG by jy around 2016: 
** LOCATION:  src/components/Reports/Reports.js
**            xt this was created in the original system in 2016
**            xt I want clean readable, maintainable code
** PLEASE PUT ALL CHANGE HISTORY NOTES HERE AS WELL AS IN THE CODE LOCATION ITSELF!!!
** PLEASE USE USA TIME FORMAT  MM/DD/YYYY  OR YYYYMMDD
** 20230801: - xt added back the change to the column width size and label of the incident #
** 20230915: - GK made changes to keep the Reports Tab table, sticky so it stays on top when scrolling.
** 20250614: - Reverted to react-bootstrap@0.33.1, replaced react-bootstrap-table-next with Bootstrap 5.x table, fixed imports to resolve 'undefined' error. - Grok/xAI
** 20250629:  w/ chat to continue removing react-bootstrap and make .css more maitainable..try to take out nutty stuff
** 20250720:  w/ chataAI, completely changed the pop modal to be ONLY our own custom modal so that Bootstrap 5.3.3 wont interfere
**.           so we made custom classNames and custom .css NOTE: css can leak from anywhere in the project
** 20261003:  xt /w AI, remove 500 report limit from downloads Report tab.
*/
import PropTypes from "prop-types";
import React, { useState, useMemo } from "react";
import { useSelector, useDipatch } from 'react-redux';
//import { Container, Row, Col } from "react-bootstrap"; // not used now
//import { Modal} from "react-bootstrap"; // rb v2
// import Dropdown from "react-bootstrap/lib/Dropdown";
// import DropdownToggle from "react-bootstrap/lib/DropdownToggle";
// import DropdownMenu from "react-bootstrap/lib/DropdownMenu";

import { FormattedDate, FormattedTime, IntlProvider } from "react-intl";
import Select from "react-select";
import moment from "moment";
import moments from "moment-timezone";
import { CSVLink } from "react-csv";
import { languageLabel } from "../../utils/Languages";
import DatePicker from "react-datepicker";
import ClipLoader from "react-spinners/ClipLoader";
import "./NewReports.css";

const Reports = ({
  dispatch,
  reports,
  agency,
  languageCode,
  profile,
  checkboxvalue,
  handleCheckBox,
  handleStatusCheckBox,
  startDate,
  endDate,
  handleStart,
  handleEnd,
  prepareFetch,
  page,
  totalPage,
  updatePageRow,
  handlePageRow,
  handlePageSize,
  handleNext,
  handlePrev,
  isFetching,
  handleCsv,
  reportCSV,
  handleclearAll,
  checkboxStatusvalue,
  handleCheckBoxLanguage,
  checkboxLanguagevalue,
  isFetchingcsv, 
  handleExportModalClose,
  en_count,
  es_count,
  count,
  inc_types,
  timezones,
  timezone,
  handleTimezone,
  height,
}) => {
  const [sortConfig, setSortConfig] = useState({ key: "incident_number", direction: "desc" });

const dateRegex = /\b\d{10,13}\b/g;
  const stringRegex = /\d{13}/g;

  const reduxState = useSelector((state) => state);
   console.log('Redux state snapshot:', reduxState);

  /**
   * xt 10-03-2026
   *
   * REPORTS CSV - ESCAPE EMBEDDED DOUBLE QUOTES
   *
   * react-csv 1.0.14 encloses CSV fields in double quotes but does not
   * escape double quotes that already exist inside a field. That can create
   * malformed CSV when report text contains embedded double quotes.
   *
   * CSV represents a literal double quote inside an enclosed field as two
   * double quotes (""). Preserve the original report text by applying that
   * CSV escaping to every string value before handing the data to CSVLink.
   *
   * This changes only the exported CSV representation. It does not modify
   * the report data stored in Redux, MongoDB, or displayed in the Console.
   */
  const escapeCsvValue = (value) =>
    typeof value === "string" ? value.replace(/"/g, '""') : value;

//const isFetchingcsv = useSelector((state) => state.reportCSV?.isFetchingcsv || "");
  console.log("csv-report  line 81 is Fetchingcsv is :", isFetchingcsv);
  const csvdata = reportCSV.map((i) => ({
    ...Object.fromEntries(
        Object.entries(i).map(([key, value]) => [
          key,
          escapeCsvValue(value),
        ])
     ),
    start: timezone
      ? moments(timezoneformatDate(i.start)).tz(timezone).format("MM/DD/YY HH:mm")
      : epocToUTCDefault(i.start),
    received: timezone
      ? moments(timezoneformatDate(i.received)).tz(timezone).format("MM/DD/YY HH:mm")
      : epocToUTCDefault(i.received),
    occurred: timezone
      ? moments(timezoneformatDate(i.occurred)).tz(timezone).format("MM/DD/YY HH:mm")
      : epocToUTCDefault(i.occurred),
    sent: timezone
      ? moments(timezoneformatDate(i.sent)).tz(timezone).format("MM/DD/YY HH:mm")
      : epocToUTCDefault(i.sent),
    messages: escapeCsvValue(
      timezone
        ? messagesToTimezone(i.messages, timezone)
        : messagesToTimezone(i.messages, "default")
    ),
    internal: escapeCsvValue(
      timezone
        ? messagesToTimezone(i.internal, timezone)
        : messagesToTimezone(i.internal, "default")
    ),
  }));

  function formatDate(cell) {
    return moment(cell).format("MM/DD/YY HH:mm");
  }

  function timezoneformatDate(cell) {
    return moment(cell).format("MM/DD/YY HH:mm");
  }

  function messagesToTimezone(text, timezone) {
    let isFirstLine = true;
    let convertedText = text.replace(dateRegex, (match) => {
      if (timezone !== "default") {
        let date = epocToUTC(match);
        let d2 = moments.tz(date, "MM/DD/YY HH:mm", timezone).format("MM/DD/YY HH:mm");
        if (isFirstLine) {
          isFirstLine = false;
          return d2;
        } else {
          return "<br>" + d2;
        }
      } else {
        if (isFirstLine) {
          isFirstLine = false;
          return epocToUTCDefault(match);
        } else {
          return "<br>" + epocToUTCDefault(match);
        }
      }
    });
    return convertedText;
  }

  function epocToUTCDefaultRes(cell) {
    let currenttimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let date = moments(timezoneformatDate(cell)).tz(currenttimezone).format("MM/DD/YY HH:mm");
    return date;
  }

  function epocToUTC(cell) {
    let date = moment.utc(+cell).toDate();
    return date;
  }

  function epocToUTCDefault(cell) {
    let currenttimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let date = moments(timezoneformatDate(Number(cell))).tz(currenttimezone).format("MM/DD/YY HH:mm");
    return date;
  }

  function startDateFormatter(cell, row) {
    return (
      <IntlProvider locale="en">
        <div>
          <FormattedDate value={cell} month="numeric" day="numeric" year="2-digit" />{" "}
          <FormattedTime value={cell} hour12={false} />
        </div>
      </IntlProvider>
    );
  }

  const headers = [
    { label: "Incident Number", key: "incident_number" },
    { label: "Type", key: "type" },
    { label: "User language", key: "user_language" },
    { label: "Status", key: "status" },
    { label: "Started D/T", key: "start" },
    { label: "Occurred D/T", key: "occurred" },
    { label: "Sent D/T", key: "sent" },
    { label: "Received D/T", key: "received" },
    { label: "Description", key: "description" },
    { label: "Photos links", key: "photos_url" },
    { label: "# Photos", key: "num_photos" },
    { label: "Location/Line/Route", key: "location" },
    { label: "Lat/Long", key: "gps" },
    { label: "Physical Address", key: "address" },
    { label: "Reporter Name", key: "reporter_name" },
    { label: "Reporter Email", key: "reporter_email" },
    { label: "Reporter Phone", key: "reporter_phone" },
    { label: "Dispatcher Communications", key: "messages" },
    { label: "Dispatcher Ack Time", key: "ack_time" },
    { label: "Dispatcher Log", key: "internal" },
  ];

  let data = [];
  let types = {};
  let stats = {};
  let languages = {};
  for (let i = 0; i < reports.length; i++) {
    let e = reports[i];
    if (types[e.type] == undefined) types[e.type] = e.type;
    if (stats[e.status] == undefined) stats[e.status] = e.status;
    const language_label = languageLabel(e.user_language);
    languages[language_label] = (languages[language_label] || 0) + 1;

    if (e.description) {
      e.description = e.description.replace(/["']/g, "");
    }
    if (e.messages) {
      e.messages = e.messages.replace(/["']/g, "");
    }

    const reportSchema = agency.details.report_schemas
      ? agency.details.report_schemas.find((schema) => schema._id === e.report_schema_id)
      : [];
    let reportStates = [];
    let reportStatuses = [];
    let selectedStatus = {};
    let selectedState = {};
    if (reportSchema) {
      reportStates = reportSchema.report_states;
      reportStatuses = reportSchema.report_statuses;
      selectedState = e.state && reportSchema.report_states
        ? reportSchema.report_states.find((state) => state._id === e.state)
        : {};
      selectedStatus = selectedState && reportStatuses
        ? reportStatuses.find((status) => status._id === selectedState.report_status_id)
        : {};
    }
    e.status = "Closed";
    reports[i].status = e.status;

    const row = {
      incident_number: e.incident_number,
      type: e.type,
      user_language: languageLabel(e.user_language),
      status: e.status,
      start: timezone
        ? moments(timezoneformatDate(e.start)).tz(timezone).format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.start),
      occurred: timezone
        ? moments(timezoneformatDate(e.occurred)).tz(timezone).format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.occurred),
      received: timezone
        ? moments(timezoneformatDate(e.received)).tz(timezone).format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.received),
      sent: timezone
        ? moments(timezoneformatDate(e.sent)).tz(timezone).format("MM/DD/YY HH:mm")
        : epocToUTCDefaultRes(e.sent),
      description: e.description,
      gps: e.gps,
      num_photos: e.num_photos,
      photos_url: e.photos_url
        .replace(/"/g, "")
        .split(",")
        .map((link) => link),
      location: e.location,
      address: "N/A",
      reporter_name: e.reporter_name,
      reporter_email: e.reporter_email,
      reporter_phone: e.reporter_phone,
      messages: timezone
        ? messagesToTimezone(e.messages, timezone)
        : messagesToTimezone(e.messages, "default"),
      internal: timezone
        ? messagesToTimezone(e.internal, timezone)
        : messagesToTimezone(e.internal, "default"),
      ack_time: e.ack_time,
    };
    data.push(row);
  }

  let languages_stats = {};
  for (let language in languages) {
    languages_stats[language] = language + ` (${languages[language]})`;
  }
  // xt 10-03-2026
// Include the selected agency name in the Reports CSV filename so exported
// files are easy to identify when administrators work with multiple agencies.
const agencyExportName = agency?.details?.name?.[languageCode]
  ? agency.details.name[languageCode]
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-zA-Z0-9_-]/g, "")
  : "Transit-Watch";

const file_name =
  `${agencyExportName}_bsg_report_export_` +
  moment().format("YYYY_MM_DD") +
  ".csv";

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedData = useMemo(() => {
    let result = [...data];
    result.sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];
      if (sortConfig.key === "photos_url") {
        aValue = aValue.join(",");
        bValue = bValue.join(",");
      }
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return result;
  }, [data, sortConfig]);

  const columns = [
    { key: "incident_number", label: "Incident #", width: "150px" },
    { key: "type", label: "Type", width: "150px" },
    { key: "user_language", label: "User Language", width: "100px" },
    { key: "status", label: "Status", width: "80px" },
    { key: "start", label: "Start", width: "110px", format: timezone ? null : startDateFormatter },
    { key: "occurred", label: "Occurred", width: "110px", format: timezone ? null : startDateFormatter },
    { key: "sent", label: "Sent", width: "110px", format: timezone ? null : startDateFormatter },
    { key: "received", label: "Received", width: "110px", format: timezone ? null : startDateFormatter },
    { key: "description", label: "Description", width: "160px" },
    { key: "num_photos", label: "# Photos", width: "80px" },
    { key: "photos_url", label: "Photos Links", width: "205px" },
    { key: "location", label: "Location/Line/Route", width: "180px" },
    { key: "gps", label: "Lat/Long", width: "150px" },
    { key: "reporter_name", label: "Reporter Name", width: "110px" },
    { key: "reporter_email", label: "Reporter Email", width: "130px" },
    { key: "reporter_phone", label: "Reporter Phone", width: "140px" },
    { key: "ack_time", label: "Ack Time", width: "99px" },
    { key: "messages", label: "Dispatcher Communications", width: "350px", format: messagesToTimezone },
    { key: "internal", label: "Dispatcher Log", width: "250px", format: messagesToTimezone },
  ];

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            fontSize: "18px",
            marginLeft: "10px",
            fontWeight: "bold",
          }}
        >
          Total Reports for Selection: {count}
        </span>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="btn btn-primary exportData-button"
              onClick={handleCsv}
              disabled={isFetchingcsv === "fetching"}
            >
              {isFetchingcsv === "fetching"
                ? "Preparing Export... Please Wait"
                : "Export All Data"}
            </button>
          </div>
        </div>
      </div>

      <div className="main-block-b">
        <div className="sidebar">
          <div style={{ width: "100%", color: "white" }}>
            <label htmlFor="timezone-select" style={{ display: "block", marginBottom: "6px" }}>
              Timezone displayed:
            </label>
            <Select
              name="form-field-name"
              clearable={false}
              // value={timezone}
              value={timezone ? { value: timezone, label: timezone } : null}
              onChange={(e) => handleTimezone(e)}
              options={["Select timezone", ...timezones].map((tz) => ({
                value: tz,
                label: tz,
              }))}
              styles={{
                option: (provided, state) => ({
                  ...provided,
                  color: "#212529",
                  backgroundColor: state.isSelected
                    ? "#cfe2ff"
                    : state.isFocused
                      ? "#e9ecef"
                      : "#ffffff",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "#212529",
                }),
                menu: (provided) => ({
                  ...provided,
                  color: "#212529",
                  backgroundColor: "#ffffff",
                }),
              }}
            />
          </div>

          <div className="sidebar-top-block">
              <span className="top-filter-heading">Filters</span>
            <span
  onClick={() => handleclearAll()}
  style={{
    display: "inline-block",
    padding: "6px 12px",
    backgroundColor: "#dc3545", // Bootstrap "danger" red
    color: "#fff",
    border: "1px solid #fff",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "0.875rem",
    textAlign: "center"
  }}
>
  Clear All
</span>
          </div>
          <div className="sidebar-item-block">
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">Date</span>
              </div>
              <div className="datepicker-output" style={{ color: "black" }}>
                <div style={{ marginTop: "10px" }}>
                  <DatePicker
                    id="startDate11"
                    selected={startDate}
                    onChange={handleStart}
                    placeholderText="Start Date"
                    className="start-datepicker form-control"
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <DatePicker
                    id="endDate11"
                    selected={endDate}
                    onChange={handleEnd}
                    placeholderText="End Date"
                    className="end-datepicker form-control"
                  />
                </div>
              </div>
              <div className="btn-output" style={{ margin: "20px 0px" }}>
                <button
                  type="button"
                  className="btn btn-primary filter-btn"
                  onClick={prepareFetch}
                >
                  Submit
                </button>
              </div>
            </div>
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">User language</span>
              </div>
              {["en_US", "es_US"].map((language) => (
                <div className="item-filter-content-b" key={language}>
                  <input
                    type="checkbox"
                    id={`lang-${language}`}
                    style={{ marginRight: "10px" }}
                    onChange={(e) => handleCheckBoxLanguage(e)}
                    value={language}
                    checked={checkboxLanguagevalue.includes(language)}
                  />
                  <label htmlFor={`lang-${language}`} className="label-item">
                    {`${language === "en_US" ? "English" : "Spanish"} (${language === "en_US" ? en_count : es_count
                      })`}
                  </label>
                  <br />
                </div>
              ))}
            </div>
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">Status</span>
              </div>
              {["new", "open", "closed"].map((st) => (
                <div className="item-filter-content-b" key={st}>
                  <input
                    type="checkbox"
                    id={`status-${st}`}
                    style={{ marginRight: "10px" }}
                    onChange={(e) => handleStatusCheckBox(e)}
                    value={st}
                    checked={checkboxStatusvalue.includes(st)}
                  />
                  <label htmlFor={`status-${st}`} className="label-item">
                    {st.toLocaleUpperCase()}
                  </label>
                  <br />
                </div>
              ))}
            </div>
            <div className="item-filter-list">
              <div className="item-top-block">
                <span className="item-header">Incident Type</span>
              </div>
              {inc_types.map((st) => (
                <div className="item-filter-content-b" key={st}>
                  <input
                    type="checkbox"
                    id={`type-${st}`}
                    style={{ marginRight: "10px" }}
                    onChange={(e) => handleCheckBox(e)}
                    value={st}
                    checked={checkboxvalue.includes(st)}
                  />
                  <label htmlFor={`type-${st}`} className="label-item">
                    {st}
                  </label>
                  <br />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="report-table">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <ClipLoader
              cssOverride={{
                position: "absolute",
                top: "300px",
                left: "auto",
                right: "auto",
                zIndex: "99999",
              }}
              size={50}
              color="black"
              loading={isFetching}
            />
          </div>
          <div
            className="center-block-div"
            style={{
              height: height,
              overflow: "auto",
            }}
          >
            <div className="center-block-container table-responsive">
              <table className="table table-striped table-hover">
                <colgroup>
                  {columns.map((col) => (
                    <col key={col.key} style={{ width: col.width || 'auto' }} />
                  ))}
                </colgroup>
                <thead className="table-dark text-medium">
                  <tr>
                    {columns.map((col) => (
                      <th
                        key={col.key}
                        onClick={() => handleSort(col.key)}
                        style={{ cursor: "pointer" }}
                      >
                        {col.label}{" "}
                        {sortConfig.key === col.key &&
                          (sortConfig.direction === "asc" ? "↑" : "↓")}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sortedData.length > 0 ? (
                    sortedData.map((row) => (
                      <tr className="text-small" key={row.incident_number}>
                        {columns.map((col) => (
                          <td key={col.key} style={{ width: col.width }}>
                            {col.format && col.key === "start" && !timezone
                              ? startDateFormatter(row[col.key])
                              : col.format && col.key === "occurred" && !timezone
                                ? startDateFormatter(row[col.key])
                                : col.format && col.key === "sent" && !timezone
                                  ? startDateFormatter(row[col.key])
                                  : col.format && col.key === "received" && !timezone
                                    ? startDateFormatter(row[col.key])
                                    : col.format && ["messages", "internal"].includes(col.key)
                                      ? <span dangerouslySetInnerHTML={{ __html: col.format(row[col.key], timezone || "default") }} />
                                      : Array.isArray(row[col.key])
                                        ? row[col.key].join(", ")
                                        : row[col.key]}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="container mt-4">
            {sortedData.length > 0 && (
              <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap">
                <button
                  type="button"
                  className="btn report-equal-width-btn bg-prev"
                  onClick={() => handlePrev(page)}
                >
                  Previous
                </button>

                <div className="d-flex align-items-center gap-2">
                  <span>Page</span>
                  <input
                    type="number"
                    className="form-control text-center"
                    style={{ width: "60px", height: "38px" }}
                    value={page}
                    onChange={(e) => handlePageSize(e)}
                  />
                  <span>of</span>
                  <span>{totalPage}</span>
                </div>
                <div className="dropdown dropup">
                  <button
                    className="btn btn-secondary dropdown-toggle mt-0"
                    type="button"
                    id="rowsDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {updatePageRow}
                  </button>
                  <ul className="dropdown-menu text-center" aria-labelledby="rowsDropdown" style={{ minWidth: "70px" }}>
                    {[10, 20, 30, 50].map((i) => (
                      <li key={i}>
                        <button
                          className="dropdown-item"
                          onClick={() => handlePageRow(i)}
                        >
                          {i}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <button
                  type="button"
                  className="btn report-equal-width-btn bg-next"
                  onClick={() => handleNext(page)}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {isFetchingcsv === "receive_data_success" && (
        <div
          className="custom-CSVexport-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="custom-CSVexport-modal-title"
          onClick={handleExportModalClose}
        >
          <div
            className="custom-CSVexport-modal-content"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="custom-CSVexport-modal-header">
              <h5 id="custom-CSVexport-modal-title">
                Your Export Is Ready
              </h5>

              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleExportModalClose}
              />
            </div>

            <div className="custom-CSVexport-modal-body">
              <div className="text-center">
                <p>
                  Your report export is ready to download.
                </p>

                <CSVLink
                  data={csvdata}
                  headers={headers}
                  filename={file_name}
                  separator=","
                  enclosingCharacter={`"`}
                  className="btn btn-primary custom-CSVexport-download-button"
                  target="_blank"
                  onClick={handleExportModalClose}
                >
                  Download
                </CSVLink>
              </div>
            </div>

            <div className="custom-CSVexport-modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleExportModalClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}


    </div> 
 );
}
 
  

Reports.propTypes = {
  reports: PropTypes.array.isRequired,
  agency: PropTypes.object.isRequired,
  languageCode: PropTypes.string.isRequired,
};

export default Reports;

